import { Component, Input } from '@angular/core';
import { LegacyProgressSpinnerMode as ProgressSpinnerMode } from '@angular/material/legacy-progress-spinner';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
})
export class ProgressSpinnerComponent {
  @Input() public diameter = 100;
  @Input() public strokeWidth = 10;
  @Input() public theme: 'default' | 'primary' = 'default';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
}
